module.exports = __webpack_public_path__ + "static/kvm_9.cd4a76bf.jpg";